'use es6';

import { trackInteraction } from '../utils/usageTracking';
import { OPEN_FIND_REPLACE_POPOVER, REPLACE_TEXT_ALL, SHOW_REPLACE } from '../constants/usageTracking';
const meta = {
  version: 'v2'
};
export const handleOnOpen = editor => {
  trackInteraction(editor, 'tinymceFindReplace', OPEN_FIND_REPLACE_POPOVER, meta);
};
export const getHandleFind = searchReplaceApi => {
  return function handleFind(value) {
    const count = value ? searchReplaceApi.find(value) : 0;
    // Clear search state on empty input
    if (!value) searchReplaceApi.done(false);
    return count;
  };
};
export const getHandleFindNext = searchReplaceApi => searchReplaceApi.next;
export const getHandleFindPrev = searchReplaceApi => searchReplaceApi.prev;
export const getHandleDone = searchReplaceApi => {
  return function handleDone() {
    searchReplaceApi.done(false);
  };
};
export const getHandleReplaceAll = (editor, searchReplaceApi) => {
  return function handleReplaceAll(value) {
    editor.undoManager.transact(() => {
      searchReplaceApi.replace(value, true, true);
    });
    trackInteraction(editor, 'tinymceFindReplace', REPLACE_TEXT_ALL, meta);
  };
};
export const getHandleToggleShowReplace = editor => {
  return function handleToggleShowReplace(isOpen) {
    if (isOpen) {
      trackInteraction(editor, 'tinymceFindReplace', SHOW_REPLACE, meta);
    }
  };
};